// extracted by mini-css-extract-plugin
export default {"tableHeader":"TableHead_tableHeader__cRyfu","scrollBar":"TableHead_scrollBar__Vv74h"};